
export const LoadingSpinner = () => {
    return (
        <section className="spinner-container scrollbar">
            <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
            </div>
        </section>
    )
}
